import Image from "next/image";
import React, { useEffect, useState } from "react";
import striptags from "striptags";

const ReadMoreText = ({ content, limit = 100 })=>{

  const [isExpanded, setIsExpanded] = useState(false);
  const shouldTruncate = content?.length > limit;
  const truncatedText = shouldTruncate ? content?.slice(0, limit) + "..." : content;

  useEffect(()=>{
    setIsExpanded(false);
  },[content]);

  return <>
    <p>{isExpanded ? striptags(content) : striptags(truncatedText)}{" "}{shouldTruncate && (
        <span className="read-more-btn" onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? "Read Less" : "Read More"}
        </span>
    )}</p>
  </>
}

const Edtech = ({ industryData }) => {
  const titleWithoutPTag = industryData?.value?.title;
  return (
    <section className="edtech-game-section">
      <div className="edtech-game-inner">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="section-heading">
                <span
                  itemProp="heading"
                  dangerouslySetInnerHTML={{
                    __html: titleWithoutPTag,
                  }}
                ></span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="section-full-image">
                <Image
                  height={4000}
                  width={4000}
                  src={industryData?.value?.image?.url}
                  alt={industryData?.value?.image?.alt_text ?? 'How can Quixom Help you Stay at the Top of your EdTech Game?'}
                  loading="eager"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="edtech-game-left">
                <h2
                  className="heading-h3"
                  dangerouslySetInnerHTML={{
                    __html: industryData?.value?.description?.title,
                  }}
                ></h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="edtech-game-right">
                {/* <p
                  dangerouslySetInnerHTML={{
                    __html: industryData?.value?.description?.description,
                  }}
                ></p> */}
                <ReadMoreText content={industryData?.value?.description?.description} limit={300} />
              </div>
            </div>
          </div>
          <div className="edtech-game-card">
            <div className="row">
              {industryData?.value?.list?.map((val, i) => {
                return (
                  <div className="col-lg-4 col-md-6" key={i}>
                    <div className="offering-card">
                      <div className="offering-card-icon">
                        <Image
                          height={100}
                          width={100}
                          src={val?.value?.image?.url}
                          alt={val?.value?.image?.alt_text ?? 'Learning Management Systems'}
                          loading="eager"
                        />
                      </div>
                      <div className="offering-card-content">
                        <span
                          className="heading-h4 offering-card-title"
                          itemProp="title"
                          dangerouslySetInnerHTML={{
                            __html: val?.value?.title,
                          }}
                        ></span>
                        <p
                          itemProp="description"
                          dangerouslySetInnerHTML={{
                            __html: val?.value?.description,
                          }}
                        ></p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Edtech;
